module.exports = __webpack_public_path__ + "static/media/YM80_8.9f1d4371.jpg";